"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDraggable = _interopRequireDefault(require("react-draggable"));

var _find = _interopRequireDefault(require("lodash/find"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _virtualizedUtilities = require("../utilities/virtualizedUtilities");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function mapInitialPropsToColumns(resultConfiguration, defaultConfiguration) {
  var columnKeys = (0, _virtualizedUtilities.getColumnKeysInOrder)(resultConfiguration);

  var _columnKeys$reduce = columnKeys.reduce(function (accumulator, currentColumn) {
    var column = (0, _find["default"])(resultConfiguration, ['fieldName', currentColumn]);
    var columnWidth = column.columnWidth === 0 || column.columnWidth < defaultConfiguration.minColumnWidth ? defaultConfiguration.defaultColumnWidth : column.columnWidth;
    var xOffset = columnWidth + accumulator.totalWidth;
    return {
      totalWidth: xOffset,
      columns: [].concat(_toConsumableArray(accumulator.columns), [_objectSpread(_objectSpread({}, column), {}, {
        columnWidth: columnWidth,
        position: xOffset
      })])
    };
  }, {
    totalWidth: 0,
    columns: []
  }),
      columns = _columnKeys$reduce.columns;

  return columns;
}

var DraggableHeader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DraggableHeader, _PureComponent);

  var _super = _createSuper(DraggableHeader);

  function DraggableHeader() {
    var _this;

    _classCallCheck(this, DraggableHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      columns: mapInitialPropsToColumns(_this.props.resultConfiguration, _this.props.defaultConfiguration),
      isDragging: false
    });

    _defineProperty(_assertThisInitialized(_this), "resizeColumn", function (_ref) {
      var fieldName = _ref.fieldName,
          deltaX = _ref.deltaX;
      var foundColumn = (0, _find["default"])(_this.state.columns, ['fieldName', fieldName]);

      if (foundColumn.columnWidth + deltaX <= _this.props.defaultConfiguration.minColumnWidth) {
        return;
      }

      _this.setState(function (prevState) {
        var prevColumns = prevState.columns;
        var indexOfColumn = (0, _findIndex["default"])(prevColumns, ['fieldName', fieldName]);
        var newColumns = prevColumns.map(function (column, index) {
          if (index < indexOfColumn) {
            return column;
          }

          if (index === indexOfColumn) {
            return _objectSpread(_objectSpread({}, column), {}, {
              columnWidth: column.columnWidth + deltaX
            });
          }

          return _objectSpread(_objectSpread({}, column), {}, {
            position: column.position + deltaX
          });
        });
        return {
          columns: newColumns,
          isDragging: true
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function () {
      _this.setState({
        isDragging: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getColumnWidth", function (fieldName) {
      var foundColumn = _this.state.columns.find(function (column) {
        return column.fieldName === fieldName;
      });

      if (!foundColumn) {
        return 0;
      }

      return foundColumn.columnWidth;
    });

    _defineProperty(_assertThisInitialized(_this), "getPosition", function (fieldName) {
      var foundColumn = _this.state.columns.find(function (column) {
        return column.fieldName === fieldName;
      });

      if (!foundColumn) {
        return {
          x: 0
        };
      }

      return {
        x: foundColumn.position
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderDraggableIcon", function (fieldName) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_reactDraggable["default"], {
          axis: "x",
          defaultClassName: "DragHandle",
          defaultClassNameDragging: "DragHandleActive",
          onDrag: function onDrag(event, _ref2) {
            var deltaX = _ref2.deltaX;

            _this.resizeColumn({
              fieldName: fieldName,
              deltaX: deltaX
            });
          },
          onStop: _this.onDragEnd,
          onMouseDown: _this.onMouseDown,
          position: _this.getPosition(fieldName),
          zIndex: 999
        },
        /*#__PURE__*/
        _react["default"].createElement("span", {
          className: "DragHandleIcon"
        }))
      );
    });

    return _this;
  }

  _createClass(DraggableHeader, [{
    key: "render",
    value: function render() {
      return this.props.children({
        renderDraggableIcon: this.renderDraggableIcon,
        getColumnWidth: this.getColumnWidth,
        isDragging: this.state.isDragging
      });
    }
  }]);

  return DraggableHeader;
}(_react.PureComponent);

exports.DraggableHeader = DraggableHeader;
DraggableHeader.propTypes = {
  children: _propTypes["default"].func.isRequired,
  defaultConfiguration: _propTypes["default"].instanceOf(Object).isRequired,
  resultConfiguration: _propTypes["default"].instanceOf(Array).isRequired
};